/**
 * Reads the message from the backend error envelope
 * (`{ error: { name, message } }`) of a failed RTK Query request, falling back
 * to a generic text when the request failed without one (e.g. network error).
 */
export function getApiErrorMessage(
    error: unknown,
    fallback = 'Something went wrong. Please try again later.',
): string {
    const message = (error as { data?: { error?: { message?: unknown } } })
        ?.data?.error?.message;
    return typeof message === 'string' && message ? message : fallback;
}
